import Header from "./Header";
import Footer from "./Footer";
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {isUserLoggedIn, preRegister, register} from "../service/AuthService";
import {red, green, ftAccessToken, ftRefreshToken} from "../constants/Constants";
import Loading from "./Loading";

function SignUp() {

    const navigate = useNavigate();

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [confirmationToken, setConfirmationToken] = useState('');
    const [form, setForm] = useState("register");
    const [progressBarWidth, setProgressBarWidth] = useState('33%');
    const [progressText, setProgressText] = useState("Step 1");

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (form === "register") {
            setProgressBarWidth("33%");
            setProgressText("Step 1");
        } else {
            setProgressBarWidth("67%")
            setProgressText("Step 2");
        }
    }, [form])

    function validatePassword() {
        // Regex explanation:
        // ^                 : start of string
        // (?=.*[a-z])       : at least one lowercase letter
        // (?=.*[A-Z])       : at least one uppercase letter
        // (?=.*\d)          : at least one number
        // .{8,}             : at least 8 characters
        // $                 : end of string
        const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;

        return regex.test(password);
    }

    const [errorSuccessMessage, setErrorSuccessMessage] = useState(null);
    const [errorSuccessOpacity, setErrorSuccessOpacity] = useState(1);

    function addErrorSuccess(message, color, passwordRestriction) {
        if (window.innerWidth >= 991 || color === green) {
            setErrorSuccessMessage(
                <div
                    className={`success-or-error ${passwordRestriction ? 'success-or-error-password-restriction' : ''}`}
                    style={{color: color, opacity: errorSuccessOpacity}}>
                    {message}
                </div>
            );
            setErrorSuccessOpacity(1);

            setTimeout(() => {
                setErrorSuccessOpacity(0);
            }, 2000);

            setTimeout(() => {
                setErrorSuccessOpacity(1);
                setErrorSuccessMessage(null);
            }, 3000);
        } else {
            window.alert(message);
        }
    }

    useEffect(() => {
        if (isUserLoggedIn()) {
            navigate("/");
        }
    }, []);

    const handlePreRegister = async (event) => {
        event.preventDefault();
        if (!validatePassword()) {
            addErrorSuccess('Password must be at least 8 characters long and must include at least 1 uppercase letter, 1 lowercase letter, and 1 number.', red, true)
        } else if (password !== confirmPassword) {
            addErrorSuccess('Passwords do not match.', red)
        } else if (!document.getElementById("agree-checkbox").checked) {
            addErrorSuccess("You must agree to the to the site's Term's & Conditions and Privacy Policy to sign up.", red, true)
        } else {
            setLoading(true);
            try {
                preRegister(email)
                    .then(preRegisterResponse => {
                        if (preRegisterResponse.confirmation === "exists") {
                            addErrorSuccess('This email already exists. Please log in.', red);
                        } else if (preRegisterResponse.confirmation === 'fail') {
                            addErrorSuccess('Error Registering Account', red);
                        } else if (preRegisterResponse.confirmation === 'success') {
                            setForm('confirm');
                        }
                        setLoading(false);
                    })
                    .catch(error => {
                        console.error("Error registering:", error);
                        addErrorSuccess('Error Registering Account', red);
                        setLoading(false);
                    });
            } catch (error) {
                console.error('Login failed:', error);
                addErrorSuccess('Error Registering Account', red);
                setLoading(false);
            }
        }

    };

    const handleConfirm = async (event) => {
        event.preventDefault();
        setLoading(true);
        try {
            register(firstName, lastName, email, password, confirmationToken)
                .then(registerResponse => {
                    localStorage.setItem(ftAccessToken, JSON.stringify(registerResponse.access_token));
                    localStorage.setItem(ftRefreshToken, JSON.stringify(registerResponse.refresh_token));
                    navigate("/account");
                    setLoading(false);
                })
                .catch(error => {
                    console.error("Error registering:", error);
                    addErrorSuccess('Error Registering Account', red);
                    setLoading(false);
                });

        } catch (error) {
            console.error('Login failed:', error);
            addErrorSuccess('Error Registering Account', red);
            setLoading(false);
        }
    };

    const confirmationForm = (
        <div className="content">
            <form className={"login-form"} onSubmit={handleConfirm} style={{position: "relative"}}>
                {errorSuccessMessage && (
                    <div className="success-or-error-login"
                         style={{color: errorSuccessMessage.props.style.color, opacity: errorSuccessOpacity}}>
                        {errorSuccessMessage.props.children}
                    </div>
                )}
                <div className="login-form-component">
                    <div className={"login-form-label"}>A confirmation code has been sent to {email}.</div>
                    <label className={"login-form-label"} htmlFor="confirmationToken">If you cannot find it, be sure to
                        check your spam folder.</label>
                    <input
                        className={"research-form-input contact-form-input"}
                        style={{marginTop: '10px'}}
                        type="text"
                        id="confirmationToken"
                        placeholder={"Confirmation Code"}
                        value={confirmationToken}
                        onChange={(e) => setConfirmationToken(e.target.value)}
                        required
                    />
                </div>
                <div className={"send-wrapper mobile-margin-bottom-0"}>
                    <button className={"submit"} type="submit">Confirm</button>
                </div>
            </form>
        </div>
    )

    const registerForm = (
        <div className="dashboard-table-wrapper">
            <form onSubmit={handlePreRegister} className={"fade-in center"} style={{position: "relative"}}>
                {errorSuccessMessage && (
                    <div className="success-or-error-login"
                         style={{color: errorSuccessMessage.props.style.color, opacity: errorSuccessOpacity}}>
                        {errorSuccessMessage.props.children}
                    </div>
                )}
                <input className={"research-form-input contact-form-input"}
                       required
                       type={"email"}
                       placeholder={"Email"}
                       value={email}
                       onChange={(e) => setEmail(e.target.value)}
                />
                <input className={"research-form-input contact-form-input"}
                       required
                       placeholder={"First Name"}
                       value={firstName}
                       onChange={(e) => setFirstName(e.target.value)}
                />
                <input className={"research-form-input contact-form-input"}
                       required
                       placeholder={"Last Name"}
                       value={lastName}
                       onChange={(e) => setLastName(e.target.value)}
                />
                <input className={"research-form-input contact-form-input"}
                       required
                       type={"password"}
                       placeholder={"Password"}
                       value={password}
                       onChange={(e) => setPassword(e.target.value)}
                />
                <input className={"research-form-input contact-form-input"}
                       required
                       type={"password"}
                       placeholder={"Confirm Password"}
                       value={confirmPassword}
                       onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <div className={"agree-checkbox-wrapper have-account login-link"} style={{margin: '1rem'}}>
                    <input type={"checkbox"}
                           id={"agree-checkbox"}
                           className={"agree-checkbox"}
                    />
                    <span>I have read, understand, and agree to this site's </span>
                    <a href="/terms.pdf"
                       target="_blank" rel="noopener noreferrer"
                       className={"click-here"}>Terms & Conditions</a>
                    <span> and </span>
                    <a href="/privacy.pdf"
                       target="_blank" rel="noopener noreferrer"
                       className={"click-here"}>Privacy Policy</a>
                    <span>.</span>
                </div>
                <div className={"send-wrapper mobile-margin-bottom-0"}>
                    <button type={"submit"} className="submit">Sign Up</button>
                </div>
            </form>
        </div>
    );

    return (
        <div className={"signup page"}>
            <Header page={"signup"}/>
            <div className={"education-title center"}>Hello!</div>
            <div className={"section-subheading"} style={{marginTop: '-1rem'}}>{progressText}</div>
            <div className={"progress-bar-container"}>
                <div className={"progress-bar-line"} style={{width: progressBarWidth}}></div>
            </div>
            <div className={"content body"}>
                <div className={"section enclosed"}>
                    {loading ?
                        <Loading/>
                        :
                        <div className={"half-section login-form"}>
                            <>
                                <div className={"section-subheading center"} style={{marginBottom: '1rem'}}>Sign Up
                                </div>
                                {form === 'register' ? registerForm : confirmationForm}
                                <div className={"have-account"}>
                                    {form === 'register' ? (
                                        <div className={"login-link"}>
                                            <span>Already have an account? Click </span>
                                            <a href={"/login"} className={"click-here"}>here</a>
                                            <span> to log in!</span>
                                        </div>
                                    ) : (
                                        <div className={"center"} style={{marginTop: ".5rem"}}>
                                            <span className={"click-here"} onClick={() => setForm("register")}>Back to Registration Form</span>
                                        </div>
                                    )}
                                </div>
                            </>
                        </div>
                    }
                </div>
            </div>
            <Footer/>
        </div>
    )
}

export default SignUp;